export default __webpack_public_path__ + "static/media/landing.fc8aeff1.png";